import React from 'react';
import '../../../styles/components/carousel-card.scss';
import BaseText from '../typography/BaseText';
export default function CarouselCard({ review }) {
  return (
    <div className="carousel-card-container bg-white mx-4 p-10 rounded shadow-md flex flex-col justify-between">
      <div>
        <span class="e-item-card-recently-viewed_stars">
          <span class="m-item-card-recently-viewed_stars__orange">★★★★★</span>
        </span>
        <BaseText className="mt-2" title={review?.description?.text} />
      </div>
      <div className="flex gap-4">
        <div>
          <BaseText fontWeight="text-bold" textColor="text-gray-300" title={review?.reviewer_name?.text} />
          <BaseText fontWeight="text-bold" textColor="text-gray-300" title={review?.reviewer_details?.text} />
        </div>
        <img className="rounded-full w-14 h-14" src={review?.photo?.url} />
      </div>
    </div>
  );
}
